/* eslint-disable */
// jshint ignore: start
import MapConst from '@/constants/topologymap';
import { Q, MapInfo } from '@/views/topologymap/js/maps';
/**
 * 모니터링 모드 커스텀 인터렉션
 * @param       {[type]} graph [description]
 * @constructor
 */
function MonitoringCustomInteraction(graph){
    this.graph = graph;
}
MonitoringCustomInteraction.prototype = {
  getToolbar: function() {
    return MapInfo.getInstance(this.graph).getToolbar(MapConst.VIEW_MODE.MONITORING);
  },
  getCanvas: function() {
    return MapInfo.getInstance(this.graph).getCanvas();
  },
  /**
   * 컨텍스트 메뉴 이벤트
   * @param  {[type]} evt   [description]
   * @param  {[type]} graph [description]
   * @return {[type]}       [description]
   */
  oncontextmenu: function(evt, graph){
    this.destroyContextmenu();

    const oncontextmenu = this.getToolbar().oncontextmenu;
    if(oncontextmenu && typeof oncontextmenu === 'function') {
      oncontextmenu(evt, graph);
    }
  },
  onmousewheel: function(evt, graph){
    var me = this;
  },
  /**
   * 더블클릭 이벤트
   * @param  {[type]} evt   [description]
   * @param  {[type]} graph [description]
   * @return {[type]}       [description]
   */
  ondblclick: function(evt, graph) {
    var target = evt.getData();
    if(target) {
      try {
        this.getToolbar().ondblClickTarget(evt, target);
      } catch (e) {
        Q.log(e);
      } finally {

      }
    }
  },
  /**
   * 마우스 오버 이벤트
   * @param  {[type]} evt   [description]
   * @param  {[type]} graph [description]
   * @return {[type]}       [description]
   */
  onmousemove: function(evt, graph) {

    if(evt.target.offsetParent.className.indexOf('Q-CanvasPanel') > -1) {
        var target = evt.getData();
        if(target instanceof Q.LanModel) {
          var model = target.get('model');
          if (model.srcIfIndex > 0 || model.dstIfIndex > 0) {
            graph.cursor = 'pointer';
            this.getToolbar().setModelToolTip(target);
          } else {
            graph.cursor = 'default';
            graph.canvasPanel.classList.remove('topology-right-click');
          }
        }else if(target instanceof Q.SubTopologymapModel) {
          graph.cursor = 'pointer';
        } else if(target instanceof Q.ManagedObjectModel) {
          graph.canvasPanel.classList.add('topology-right-click');
          this.getToolbar().setModelToolTip(target);
        } else if(target instanceof Q.Custom1Model) {
          graph.cursor = 'pointer';
        } else {
          graph.cursor = 'default';
          graph.canvasPanel.classList.remove('topology-right-click');
        }

        // NoActionCustomInteraction 에서는 커서 변경 안함
        if (graph.interactionMode === MapConst.INTERACTION.NO_ACTION) {
          graph.cursor = 'default';
          graph.canvasPanel.classList.remove('topology-right-click');
        }
    } else {
      graph.cursor = 'default';
      graph.canvasPanel.classList.remove('topology-right-click');
    }
  },
  /**
   * 좌클릭 다운 이벤트
   * 컨텍스트 메뉴가 아닌 영역을 클릭하면 현재 표현되고있는 컨텍스트 메뉴를 없앤다.
   * @param  {[type]} evt   [description]
   * @param  {[type]} graph [description]
   * @return {[type]}       [description]
   */
  onstart:function(evt, graph) {
    if(evt.target.offsetParent.className.indexOf('Q-CanvasPanel') > -1) {
      this.destroyContextmenu();
      graph.unSelectAll();

      var target = evt.getData();
      if(target) {
        graph.select(target);
      }
    }
  },
  /**
   * 클릭 이벤트
   * 오브젝트 클릭만 허용한다.
   * @param  {[type]} evt   [description]
   * @param  {[type]} graph [description]
   * @return {[type]}       [description]
   */
  onclick:function(evt, graph) {
    if(evt.target.offsetParent.className.indexOf('Q-CanvasPanel') > -1) {
      var target = evt.getData();
      if(target) {
        try {
          this.getToolbar().onClickTarget(evt, target);
        } catch (e) {
          Q.log(e);
        } finally {

        }
      } else {
        // 빈 화면 클릭했을 때 하이라이트 해제
        this.getCanvas().mapHighlightTargetElement(evt, null);
      }
    }
  },
  /**
   * 우클릭 다운 이벤트
   * 현재 표현되고있는 컨텍스트 메뉴를 없앤다.
   * @param  {[type]} evt   [description]
   * @param  {[type]} graph [description]
   * @return {[type]}       [description]
   */
  onstart2:function(evt, graph) {
    graph.unSelectAll();

    this.destroyContextmenu();

    if(evt.getData()) {
      graph.select(evt.getData());
    }
  },
  onlongpress:function(evt, graph) {
    if(evt.target.offsetParent.className.indexOf('Q-CanvasPanel') > -1) {
      var target = evt.getData();
      if(target) {
        window.isLongpressHighlight = true;
        this.getCanvas().mapHighlightTargetElement(evt, target);
      }
    }
  },
  onrelease:function(evt, graph) {
    if(evt.target.offsetParent.className.indexOf('Q-CanvasPanel') > -1) {
      if (window.isLongpressHighlight) {
        window.isLongpressHighlight = false;
        this.getCanvas().mapHighlightTargetElement(evt, null);
      }
    }
  },
  /**
   * 컨텍스트 메뉴 Destroy
   */
  destroyContextmenu :function() {
    window.$$VContextmenu.undefined.hide();
  },
}

/**
 * 사용자 액션 거부 모드 커스텀 인터렉션
 * @param       {[type]} graph [description]
 * @constructor
 */
function NoActionCustomInteraction(graph){
    this.graph = graph;
}
NoActionCustomInteraction.prototype.getToolbar = MonitoringCustomInteraction.prototype.getToolbar;
NoActionCustomInteraction.prototype.getCanvas = MonitoringCustomInteraction.prototype.getCanvas;
NoActionCustomInteraction.prototype.onmousemove = MonitoringCustomInteraction.prototype.onmousemove;

/**
 * 편집 모드 커스텀 인터렉션
 * @param       {[type]} graph [description]
 * @constructor
 */
function EditCustomInteraction(graph) {
	this.graph = graph;

  // 편집 되돌리기 기능을 위해 사용자액션을 감지하여 이력화시킨다.
  this.graph.interactionDispatcher.removeListener(this.interactionListener.bind(this));
	this.graph.interactionDispatcher.addListener(this.interactionListener.bind(this));
}
EditCustomInteraction.prototype = {
  getToolbar: function() {
    return MapInfo.getInstance(this.graph).getToolbar(MapConst.VIEW_MODE.EDIT);
  },
  getCanvas: function() {
    return MapInfo.getInstance(this.graph).getCanvas();
  },
  interactionListener: function(evt) {
    switch (evt.kind) {
			case Q.InteractionEvent.ELEMENT_REMOVED:
        if(evt.data) {
          MapInfo.getInstance(this.graph).addEditHistory({
            type: MapConst.HISTORY_TYPE.REMOVE,
            elements: evt.data
          });
        }
				break;
			case Q.InteractionEvent.ELEMENT_MOVE_START:
        if(evt.datas) {
          var elements= [];
          evt.datas.forEach(function(item) {
            if(item instanceof Q.Node) {
              elements.push({
                element: item,
                x: item.x,
                y: item.y
              });
            }
          });
          MapInfo.getInstance(this.graph).addEditHistory({
            type: MapConst.HISTORY_TYPE.LOCATION,
            elements: elements
          });
        }
				break;
			case Q.InteractionEvent.RESIZE_START:
        if(evt.data) {
          var item = evt.data;
          var elements= [];
            if(item instanceof Q.Node && !(item instanceof Q.Bus)) {
              elements.push({
                element: item,
                x: item.x,
                y: item.y,
                width: item.size.width,
                height: item.size.height
              });
            }
          MapInfo.getInstance(this.graph).addEditHistory({
            type: MapConst.HISTORY_TYPE.SIZE,
            elements: elements
          });
        }
				break;
			default:
		}
  },
  /**
   * 컨텍스트 메뉴 이벤트
   * @param  {[type]} evt   [description]
   * @param  {[type]} graph [description]
   * @return {[type]}       [description]
   */
  oncontextmenu: function(evt, graph){
    this.destroyContextmenu();

    const callback = this.getToolbar().oncontextmenu;
    if(callback && typeof callback === 'function') {
      callback(evt, graph);
    }
  },
  onmousewheel: function(evt, graph){
    var me = this;
  },
  /**
   * 마우스 오버 이벤트
   * @param  {[type]} evt   [description]
   * @param  {[type]} graph [description]
   * @return {[type]}       [description]
   */
  onmousemove: function(evt, graph) {
    if(evt.target.offsetParent.className.indexOf('Q-CanvasPanel') > -1) {
      this.getToolbar().highlightLan(evt.getData());
    }
  },
  /**
   * 좌클릭 이벤트
   * @param  {[type]} evt   [description]
   * @param  {[type]} graph [description]
   * @return {[type]}       [description]
   */
  onstart:function(evt, graph) {
    if(evt.target.offsetParent.className.indexOf('Q-CanvasPanel') > -1) {
      this.destroyContextmenu();
    }
  },
  onclick:function(evt, graph) {
    if(evt.target.offsetParent.className.indexOf('Q-CanvasPanel') > -1) {
      var target = evt.getData();
      if(target) {
        try {
          this.getToolbar().onClickTarget(evt, target, graph);
        } catch (e) {
          Q.log(e);
        } finally {

        }
      }
    }
  },
  /**
   * 우클릭 이벤트
   * @param  {[type]} evt   [description]
   * @param  {[type]} graph [description]
   * @return {[type]}       [description]
   */
  onstart2:function(evt, graph) {
    this.destroyContextmenu();
  },
  /**
   * 영역 드래그 완료 이벤트
   * @param  {[type]} evt   [description]
   * @param  {[type]} graph [description]
   * @return {[type]}       [description]
   */
  enddrag:function(evt, graph) {
  },
  /**
   * 키다운 이벤트
   * @param  {[type]} evt   [description]
   * @param  {[type]} graph [description]
   * @return {[type]}       [description]
   */
  onkeydown:function(evt, graph) {
    this.getToolbar().onkeydown(evt, graph);
    this.getToolbar().onkeyupdown(evt, graph);
  },
  /**
   * 키업 이벤트
   * @param  {[type]} evt   [description]
   * @param  {[type]} graph [description]
   * @return {[type]}       [description]
   */
  onkeyup:function(evt, graph) {
    this.getToolbar().onkeyupdown(evt, graph);
  },
  /**
   * 컨텍스트 메뉴 Destroy
   */
  destroyContextmenu :function() {
    window.$$VContextmenu.undefined.hide();
  },
}

// 키보드로 화면 이동하는 이벤트를 제거한다.
delete Q.PanInteraction.prototype.onkeydown;

// Ctrl키를 누를 상태에서 여백을 클릭 했을 때 선택 된 오브젝트가 선택해제되는 것을 막기위해 재정의
Q.SelectionInteraction.prototype.onstart = function(evt, graph) {
  if (!evt.responded) {
      var target = evt.getData();
      if (target && !graph.isSelectable(target) && (target = null), target && Q.isMetaKey(evt)) {
          graph.reverseSelect(target);
          var n = new Q.InteractionEvent(graph, Q.InteractionEvent.SELECT, evt, graph.selectionModel);
          return void graph.onInteractionEvent(n)
      }
      if (!target || !graph.selectionModel.isSelected(target)) {
          target ? (graph.setSelection(target), graph.sendToTop(target)) : (Q.isMetaKey(evt) ? null : graph.setSelection(null));
          var n = new Q.InteractionEvent(graph, Q.InteractionEvent.SELECT, evt, graph.selectionModel);
          graph.onInteractionEvent(n)
      }
  }
};

// 도형에 더블클릭했을 때 Point 생기지 않도록하기 위해 재정의
Q.PointsInteraction.prototype.ondblclick = function(t, e) {
  if (!e.editable) return void(this.element && this.destroy(e));
  var i = t.getData();
  return !i || i == this.element || i._editting || i instanceof Q.ShapeNode ? void this.destroy(e) : void this._3a(i)
};

// 곡선은 Alt키를 사용한 꼭지점 추가 기능에서 제외
Q.PointsInteraction.prototype.onclick = function(t, e) {
  if (e.editable && t.altKey && this.element) {

    if (this.element.properties.lineDirection == 'SEGMENT_CURVE_TO') {
      return;
    }

    var i = this._gc(t, e);
    if (i && i.isControlPoint) return void(i.index >= 0 && this.element.removePathSegmentByIndex(i.index));
    if (this.element == t.getData()) {
      var n = e.toLogical(t), s = e.getUI(this.element);
      s.addPoint(n.x, n.y, this.handlerSize || 2)
    }
  }
};

// 곡선은 Alt키를 사용한 꼭지점 추가 커서 모양 변경에서 제외
Q.PointsInteraction.prototype.onmousemove = function(t, e) {
  this.element && this.element.properties.lineDirection != 'SEGMENT_CURVE_TO' && (e.cursor = t.altKey && (this._gc(t, e) || this.element == t.getData()) ? "crosshair" : null)
};

//모니터링 모드
Q.Defaults.registerInteractions(MapConst.INTERACTION.MONITORING, [
  MonitoringCustomInteraction,
  // Q.SelectionInteraction,
  Q.WheelZoomInteraction,
  Q.ExportInteraction,
  Q.PanInteraction,
  Q.DoubleClickInteraction,
  Q.TooltipInteraction,
]);

//사용자 액션 거부 모드 (외부 기능에서 연계할 때 사용된다.)
Q.Defaults.registerInteractions(MapConst.INTERACTION.NO_ACTION, [
  NoActionCustomInteraction,
  // Q.WheelZoomInteraction,
  // Q.PanInteraction,
  Q.TooltipInteraction,
]);

//이동 모드
Q.Defaults.registerInteractions(MapConst.INTERACTION.EDIT_MOVE, [
  EditCustomInteraction,
  // Q.EditInteraction,
  Q.ResizeInteraction,
  Q.PointsInteraction,
  Q.SelectionInteraction,
  Q.MoveInteraction,
  Q.PanInteraction,
  Q.WheelZoomInteraction,
  Q.ExportInteraction,
  Q.DoubleClickInteraction,
  Q.RectangleSelectionInteractionByRightButton,
  // Q.TooltipInteraction,
]);

//기본 편집 모드 (영역 선택)
Q.Defaults.registerInteractions(MapConst.INTERACTION.EDIT_SELECTION, [
  EditCustomInteraction,
  // Q.EditInteraction,
  Q.ResizeInteraction,
  Q.PointsInteraction,
  Q.SelectionInteraction,
  Q.MoveInteraction,
  Q.RectangleSelectionInteraction,
  Q.PanInteraction,
  Q.WheelZoomInteraction,
  Q.ExportInteraction,
  Q.DoubleClickInteraction,
  // Q.TooltipInteraction,
]);

//편집 회선 연결 모드
Q.Defaults.registerInteractions(MapConst.INTERACTION.EDIT_LINE, [
  EditCustomInteraction,
  // Q.PointsInteraction,
  Q.CreateEdgeInteraction,
  // Q.PanInteraction,
  Q.WheelZoomInteraction,
  Q.ExportInteraction,
]);
// jshint ignore:end
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/views/topologymap/js/interaction.js